import { useState } from "react";
import { usePlace } from "../../../providers/PlaceProvider";
import BaseChip from "./BaseChip";
import { CommonPlaceChip } from "./CommonPlaceChip";
import type { BoxProps } from "@mui/material";

export function PlaceChip(props: BoxProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { selectedPlace } = usePlace();

  return (
    <>
      <BaseChip
        color="secondary.main"
        label={selectedPlace?.label || "Choisir une enseigne"}
        dropdownIcon={true}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        {...props}
      />
      <CommonPlaceChip open={open} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
    </>
  );
}
